import { Row, Col } from 'antd';

import { FormButton } from 'common/components';

import { DollarCircleOutlined } from '@ant-design/icons';

import {
  RequiredActiveProductModal,
  RequiredActiveProductRoot,
  RequiredActiveProductSection,
} from '../RequiredActiveProduct';

import { useRequiredActiveProductModal } from '../hooks';
import { useCheckCreditCardPermission } from 'hooks/useCheckCreditCardPermission';
import { useCheckPaymentTermMonthAndMemberStatusCreditReview } from 'hooks/member/useCheckPaymentTermMonthAndMemberStatusCreditReview';

export const ChargeActiveProduct = (props) => {
  const { entityId, entityType } = props;

  const { canPayViaCreditCard: hasPermissionActiveProduct } =
    useCheckCreditCardPermission();
  const isPaymentTermMonthAndMemberStatusCreditReview =
    useCheckPaymentTermMonthAndMemberStatusCreditReview();

  const {
    visibleModalRequiredActiveProduct,
    onModalRequiredActiveProduct,
    offModalRequiredActiveProduct,
  } = useRequiredActiveProductModal();

  return (
    <>
      <Row>
        <Col
          xl={{
            offset: 0,
            span: 24,
          }}
          xxl={{
            offset: 8,
          }}
        >
          <FormButton
            text='Active Product'
            onClick={onModalRequiredActiveProduct}
            icon={<DollarCircleOutlined style={{ fontSize: 14 }} />}
            disabled={
              !hasPermissionActiveProduct ||
              isPaymentTermMonthAndMemberStatusCreditReview
            }
          />
        </Col>
      </Row>
      {visibleModalRequiredActiveProduct && (
        <RequiredActiveProductRoot>
          <RequiredActiveProductModal
            visible={visibleModalRequiredActiveProduct}
            onCancel={offModalRequiredActiveProduct}
            entityId={entityId}
            entityType={entityType}
          >
            <RequiredActiveProductSection
              entityId={entityId}
              entityType={entityType}
            />
          </RequiredActiveProductModal>
        </RequiredActiveProductRoot>
      )}
    </>
  );
};
